export default function setCurrentMarkup(state, action) {
  const { id, markupType } = action

  return Object.assign({}, state, {
    currentEntity: {
      type: markupType,
      id
    },
    map: {
      ...state.map,
      currentMarkup: id
    },
    ui: {
      ...state.ui,
      sidebarView: 'cameraDetails'
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/setCurrentMarkup.js